import { DOCUMENT } from "@angular/common";
// Adjust the path as needed
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "./shared/services/translation.service";

export function delayBootstrapping(translationService: TranslationService, document: Document, translate: TranslateService): () => Promise<void> {
  return () => new Promise<void>((resolve) => {
    setTimeout(() => {
      new BootstrapLoader(translationService, document, translate);
      resolve();
    }, 500);
  });
}
export class BootstrapLoader {
    constructor(
      private translationService: TranslationService,
      private document: Document,
      private translate: TranslateService
    ) {
      this.initializeLanguage();
    }
  
    private initializeLanguage() {
      let currentLang = this.translationService.getSelectedLanguage();
      if (currentLang) {
        this.translationService.setLanguage(currentLang).subscribe(() => {
          this.applyStylesBasedOnLanguage(currentLang);
        });
      } else {
        const browserLang = this.translate.getBrowserLang();
        currentLang = browserLang?.match(/en|es|ar|ru|cn|ja|ko/) ? browserLang : 'en';
        this.translationService.setLanguage(currentLang).subscribe(() => {
          this.applyStylesBasedOnLanguage(currentLang);
        });
      }
    }
  
    private applyStylesBasedOnLanguage(lang: string) {
      //need to update it accordignt o nowa
      // if (lang === 'ar') {
      //   this.setDynamicStyle('main-style', lang);
      //   this.setDynamicStyle('common-style', lang);
      //   this.setDynamicStyle('bootstrap-style', lang);
      // } else {
      //   this.setDynamicStyle('main-style', '');
      //   this.setDynamicStyle('common-style', '');
      //   this.setDynamicStyle('bootstrap-style', '');
      // }
    }
  
    // private setDynamicStyle(styleName: string, lang: string) {
    //   const head = this.document.getElementsByTagName('head')[0];
    //   let themeLink = this.document.getElementById(`${styleName}`) as HTMLLinkElement;
    //   if (themeLink) {
    //     themeLink.href = lang ? `${styleName}-ar.css` : `${styleName}.css`;
    //   } else {
    //     const style = this.document.createElement('link');
    //     style.id = `${styleName}`;
    //     style.rel = 'stylesheet';
    //     style.href = lang ? `${styleName}-ar.css` : `${styleName}.css`;
    //     head.appendChild(style);
    //   }
    // }
  }
  